import React, { useMemo } from 'react';
import { translate } from '../../services/translate';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';
import { StorageTypeFilter } from '../../schemas/cameras';

type Props = {
    zIndex?: number;
    disabled?: boolean;
    includeAllOptions?: boolean;
    labelFontSize?: number;
    required: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value?: StorageTypeFilter;
    setValue: React.Dispatch<React.SetStateAction<StorageTypeFilter | undefined>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function CameraStorageDropdown({ value, setValue, zIndex, disabled, includeAllOptions, labelFontSize, required, fieldName, form }: Props) {
    const items = useMemo(() => {
        const options = [{
            label: 'storageCloud',
            value: 'cloud'
        }, {
            label: 'storageCard',
            value: 'card'
        }];

        const mapped = options.map(type => ({ label: translate(type.label), value: type.value }));

        if (includeAllOptions) {
            mapped.unshift({ label: translate('all'), value: 'all' });
        }

        return mapped;
    }, [includeAllOptions]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('storage')}
            items={items}
            multiple={false}
            fieldName={fieldName}
            form={form}
            zIndex={zIndex}
            disabled={disabled}
            labelFontSize={labelFontSize}
            required={required}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return <FilterDropdown
            label={translate('storage')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value ?? ''}
            zIndex={zIndex}
            disabled={disabled}
            labelFontSize={labelFontSize}
            required={required}
        />;
    }
}

export default CameraStorageDropdown;
